import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import SelectedFulfillmentOptions from 'bento-ordering/base/components/SelectedFulfillmentOptions';
import CartFulfillmentMethod from 'bento-ordering/cart/components/CartFulfillmentMethod';
import { LEFT } from 'bento-ordering/base/constants/alignment';
import FeatureFlag from 'bento-ordering/base/components/FeatureFlag';
import { ENABLE_DELIVERY } from 'bento-ordering/base/constants/flags';

class CartFulfillment extends React.Component {
  static propTypes = {
    fulfillmentDate: PropTypes.string,
    fulfillmentTime: PropTypes.string,
    restaurantName: PropTypes.string,
    requestedFulfillmentIsAsap: PropTypes.bool,
    currentPrepTime: PropTypes.number,
    changeFulfillment: PropTypes.func,
    fulfillmentMethod: PropTypes.string,
    fulfillmentTimeOrASAP: PropTypes.string,
    fulfillmentAddress: PropTypes.string
  };

  render() {
    const {
      restaurantName,
      requestedFulfillmentIsAsap,
      fulfillmentDate,
      fulfillmentTime,
      currentPrepTime,
      changeFulfillment,
      fulfillmentMethod,
      fulfillmentTimeOrASAP,
      fulfillmentAddress
    } = this.props;
    return (
      <FeatureFlag
        flag={ENABLE_DELIVERY}
        renderComponent={
          <CartFulfillmentMethod
            fulfillmentAddress={fulfillmentAddress}
            fulfillmentTimeOrASAP={fulfillmentTimeOrASAP}
            changeFulfillment={changeFulfillment}
            requestedFulfillmentIsAsap={requestedFulfillmentIsAsap}
            fulfillmentDate={fulfillmentDate}
            fulfillmentTime={fulfillmentTime}
            currentPrepTime={currentPrepTime}
            desktopAlign={LEFT}
            fulfillmentMethod={fulfillmentMethod}
            dataTestId="cart-fulfillment-method"
            restaurantName={restaurantName}
          />
        }
        fallbackComponent={
          <SelectedFulfillmentOptions
            restaurantName={restaurantName}
            changePickupTime={changeFulfillment}
            requestedFulfillmentIsAsap={requestedFulfillmentIsAsap}
            fulfillmentDate={fulfillmentDate}
            fulfillmentTime={fulfillmentTime}
            currentPrepTime={currentPrepTime}
            desktopAlign={LEFT}
            dataTestId="cart-pickup-time"
          />
        }
      />
    );
  }
}
export default withRouter(CartFulfillment);
